import script from "./StakingSteps.vue?vue&type=script&setup=true&lang=ts"
export * from "./StakingSteps.vue?vue&type=script&setup=true&lang=ts"

const __exports__ = script;

export default __exports__